import PropTypes from "prop-types"
import React, { useContext, useState } from "react"

import { connect, useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"

// Reactstrap

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"



//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import { useEffect } from "react"
import { deleteAdminUserBannerMessages, deleteBannerMessages } from "store/banner-messages/actions"
import { logo, logoLightSvg } from "helpers/sf_constants"
import AdminUserProfileMenu from "components/CommonForBoth/TopbarDropdown/AdminUserProfileMenu"
import { AppContext, getPrimaryTextClass } from "helpers/sf_utils"
import BannerMessage from "components/Common/BannerMessage"
import { bsh_getBothPrevAndCurrentAdminUserDetails } from "helpers/sf_browser_storage_helper"
import _ from "lodash"

const Header = props => {
  const [search, setsearch] = useState(false)
  const [megaMenu, setmegaMenu] = useState(false)
  const [socialDrp, setsocialDrp] = useState(false)
  const { isSidebarMinimized, setIsSidebarMinimized } = useContext(AppContext);
  const dispatch = useDispatch();

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      setIsSidebarMinimized(!isSidebarMinimized)
      body.classList.toggle("sidebar-enable")
    }
  }

  const { banner_messages, current_user, current_admin_user, current_account, admin_user_banner_messages } = useSelector(state => ({
    admin_user_banner_messages: state.BannerMessages.admin_user_banner_messages,
    banner_messages: state.BannerMessages.banner_messages,
    current_user: state.Login.current_user,
    current_admin_user: state.LoginAdminUser.current_user,
    current_account: state.accounts.current_account,
  }));
  const [banners, setBanners] = useState([]);
  const [adminUserBanners, setAdminUserBanners] = useState([]);

  useEffect(() => {
    setBanners(() => {
      let newBanners = _.cloneDeep(banner_messages);
      newBanners.sort((a, b) => b.id - a.id);
      return newBanners;
    })
  }, [banner_messages])

  useEffect(() => {
    setAdminUserBanners(() => {
      let newAdminUserBanners = _.cloneDeep(admin_user_banner_messages);
      newAdminUserBanners.sort((a, b) => b.id - a.id);
      return newAdminUserBanners;
    })
  }, [admin_user_banner_messages])

  const onCloseUserNotification = (message) => {
    const data = {
      id: message.id
    }
    dispatch(deleteBannerMessages(data))
  }

  const onCloseAdminUserNotification = (message) => {
    const data = {
      id: message.id
    }
    dispatch(deleteAdminUserBannerMessages(data))
  }

  const both_admin_token = bsh_getBothPrevAndCurrentAdminUserDetails();

  return (
    <React.Fragment>
      <header id="page-topbar">
        {banners && (banners.length > 0) && (
          <BannerMessage banner={banners[0]} notification_count={banners?.length} onClickClose={onCloseUserNotification} />
        )}

        {adminUserBanners && (adminUserBanners.length > 0) && (
          <BannerMessage banner={adminUserBanners[0]} notification_count={adminUserBanners?.length} onClickClose={onCloseAdminUserNotification} />
        )}

        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            {
              localStorage.getItem("adminAccess") && (
                <div className="font-size-18 align-self-center text-black">
                  Admin View: Logged into <strong className={`${getPrimaryTextClass()}`}>
                    {current_account && current_account?.company_name || ""}
                  </strong>
                  {" "}
                  {current_account && current_account?.company_name && "#" + current_account?.id || ""}
                </div>
              )
            }

            {
              both_admin_token.current_token && both_admin_token.prev_token && (
                <div className="font-size-18 align-self-center text-black">
                  Logged into Employee: <strong className={`${getPrimaryTextClass()}`}>
                    {current_admin_user && (current_admin_user?.first_name || "") + " " + (current_admin_user?.last_name || "")}
                  </strong>
                  {" "}
                  {current_admin_user && "#" + current_admin_user?.id || ""}
                </div>
              )
            }
          </div>
          <div className="d-flex">
            {
              props.isAdminLayout ? <AdminUserProfileMenu /> : <ProfileMenu />
            }

          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
